"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const addresses_1 = tslib_1.__importDefault(require("./stanzas/addresses"));
const avatar_1 = tslib_1.__importDefault(require("./stanzas/avatar"));
const bind_1 = tslib_1.__importDefault(require("./stanzas/bind"));
const blocking_1 = tslib_1.__importDefault(require("./stanzas/blocking"));
const bob_1 = tslib_1.__importDefault(require("./stanzas/bob"));
const bookmarks_1 = tslib_1.__importDefault(require("./stanzas/bookmarks"));
const bosh_1 = tslib_1.__importDefault(require("./stanzas/bosh"));
const carbons_1 = tslib_1.__importDefault(require("./stanzas/carbons"));
const command_1 = tslib_1.__importDefault(require("./stanzas/command"));
const csi_1 = tslib_1.__importDefault(require("./stanzas/csi"));
const dataforms_1 = tslib_1.__importDefault(require("./stanzas/dataforms"));
const delayed_1 = tslib_1.__importDefault(require("./stanzas/delayed"));
const disco_1 = tslib_1.__importDefault(require("./stanzas/disco"));
const error_1 = tslib_1.__importDefault(require("./stanzas/error"));
const eme_1 = tslib_1.__importDefault(require("./stanzas/eme"));
const extdisco_1 = tslib_1.__importDefault(require("./stanzas/extdisco"));
const file_1 = tslib_1.__importDefault(require("./stanzas/file"));
const file3_1 = tslib_1.__importDefault(require("./stanzas/file3"));
const forwarded_1 = tslib_1.__importDefault(require("./stanzas/forwarded"));
const framing_1 = tslib_1.__importDefault(require("./stanzas/framing"));
const geoloc_1 = tslib_1.__importDefault(require("./stanzas/geoloc"));
const hash_1 = tslib_1.__importDefault(require("./stanzas/hash"));
const hats_1 = tslib_1.__importDefault(require("./stanzas/hats"));
const hints_1 = tslib_1.__importDefault(require("./stanzas/hints"));
const iceUdp_1 = tslib_1.__importDefault(require("./stanzas/iceUdp"));
const ibb_1 = tslib_1.__importDefault(require("./stanzas/ibb"));
const iq_1 = tslib_1.__importDefault(require("./stanzas/iq"));
const jidprep_1 = tslib_1.__importDefault(require("./stanzas/jidprep"));
const jingle_1 = tslib_1.__importDefault(require("./stanzas/jingle"));
const json_1 = tslib_1.__importDefault(require("./stanzas/json"));
const logging_1 = tslib_1.__importDefault(require("./stanzas/logging"));
const mam_1 = tslib_1.__importDefault(require("./stanzas/mam"));
const markers_1 = tslib_1.__importDefault(require("./stanzas/markers"));
const message_1 = tslib_1.__importDefault(require("./stanzas/message"));
const mood_1 = tslib_1.__importDefault(require("./stanzas/mood"));
const muc_1 = tslib_1.__importDefault(require("./stanzas/muc"));
const nick_1 = tslib_1.__importDefault(require("./stanzas/nick"));
const omemo_1 = tslib_1.__importDefault(require("./stanzas/omemo"));
const oob_1 = tslib_1.__importDefault(require("./stanzas/oob"));
const ping_1 = tslib_1.__importDefault(require("./stanzas/ping"));
const presence_1 = tslib_1.__importDefault(require("./stanzas/presence"));
const private_1 = tslib_1.__importDefault(require("./stanzas/private"));
const psa_1 = tslib_1.__importDefault(require("./stanzas/psa"));
const pubsub_1 = tslib_1.__importDefault(require("./stanzas/pubsub"));
const pubsubError_1 = tslib_1.__importDefault(require("./stanzas/pubsubError"));
const pubsubEvents_1 = tslib_1.__importDefault(require("./stanzas/pubsubEvents"));
const pubsubOwner_1 = tslib_1.__importDefault(require("./stanzas/pubsubOwner"));
const push_1 = tslib_1.__importDefault(require("./stanzas/push"));
const reach_1 = tslib_1.__importDefault(require("./stanzas/reach"));
const register_1 = tslib_1.__importDefault(require("./stanzas/register"));
const references_1 = tslib_1.__importDefault(require("./stanzas/references"));
const roster_1 = tslib_1.__importDefault(require("./stanzas/roster"));
const rsm_1 = tslib_1.__importDefault(require("./stanzas/rsm"));
const rtp_1 = tslib_1.__importDefault(require("./stanzas/rtp"));
const rtt_1 = tslib_1.__importDefault(require("./stanzas/rtt"));
const sasl_1 = tslib_1.__importDefault(require("./stanzas/sasl"));
const session_1 = tslib_1.__importDefault(require("./stanzas/session"));
const shim_1 = tslib_1.__importDefault(require("./stanzas/shim"));
const sm_1 = tslib_1.__importDefault(require("./stanzas/sm"));
const stream_1 = tslib_1.__importDefault(require("./stanzas/stream"));
const streamError_1 = tslib_1.__importDefault(require("./stanzas/streamError"));
const streamFeatures_1 = tslib_1.__importDefault(require("./stanzas/streamFeatures"));
const time_1 = tslib_1.__importDefault(require("./stanzas/time"));
const tune_1 = tslib_1.__importDefault(require("./stanzas/tune"));
const upload_1 = tslib_1.__importDefault(require("./stanzas/upload"));
const vcard_1 = tslib_1.__importDefault(require("./stanzas/vcard"));
const version_1 = tslib_1.__importDefault(require("./stanzas/version"));
const visibility_1 = tslib_1.__importDefault(require("./stanzas/visibility"));
const xrd_1 = tslib_1.__importDefault(require("./stanzas/xrd"));
const Namespaces = tslib_1.__importStar(require("./namespaces"));
exports.Namespaces = Namespaces;
const shortcuts_1 = tslib_1.__importDefault(require("./shortcuts"));
const types_1 = tslib_1.__importDefault(require("./types"));
const JID = tslib_1.__importStar(require("./jid"));
exports.JID = JID;
function default_1(JXT) {
    JXT.use(types_1.default);
    JXT.use(shortcuts_1.default);
    JXT.use(addresses_1.default);
    JXT.use(avatar_1.default);
    JXT.use(bind_1.default);
    JXT.use(blocking_1.default);
    JXT.use(bob_1.default);
    JXT.use(bookmarks_1.default);
    JXT.use(bosh_1.default);
    JXT.use(carbons_1.default);
    JXT.use(command_1.default);
    JXT.use(csi_1.default);
    JXT.use(dataforms_1.default);
    JXT.use(delayed_1.default);
    JXT.use(disco_1.default);
    JXT.use(error_1.default);
    JXT.use(eme_1.default);
    JXT.use(extdisco_1.default);
    JXT.use(file_1.default);
    JXT.use(file3_1.default);
    JXT.use(forwarded_1.default);
    JXT.use(framing_1.default);
    JXT.use(geoloc_1.default);
    JXT.use(hash_1.default);
    JXT.use(hats_1.default);
    JXT.use(hints_1.default);
    JXT.use(iceUdp_1.default);
    JXT.use(ibb_1.default);
    JXT.use(iq_1.default);
    JXT.use(jidprep_1.default);
    JXT.use(jingle_1.default);
    JXT.use(json_1.default);
    JXT.use(logging_1.default);
    JXT.use(mam_1.default);
    JXT.use(markers_1.default);
    JXT.use(message_1.default);
    JXT.use(mood_1.default);
    JXT.use(muc_1.default);
    JXT.use(nick_1.default);
    JXT.use(omemo_1.default);
    JXT.use(oob_1.default);
    JXT.use(ping_1.default);
    JXT.use(presence_1.default);
    JXT.use(private_1.default);
    JXT.use(psa_1.default);
    JXT.use(pubsub_1.default);
    JXT.use(pubsubError_1.default);
    JXT.use(pubsubEvents_1.default);
    JXT.use(pubsubOwner_1.default);
    JXT.use(push_1.default);
    JXT.use(reach_1.default);
    JXT.use(register_1.default);
    JXT.use(references_1.default);
    JXT.use(roster_1.default);
    JXT.use(rsm_1.default);
    JXT.use(rtp_1.default);
    JXT.use(rtt_1.default);
    JXT.use(sasl_1.default);
    JXT.use(session_1.default);
    JXT.use(shim_1.default);
    JXT.use(sm_1.default);
    JXT.use(stream_1.default);
    JXT.use(streamError_1.default);
    JXT.use(streamFeatures_1.default);
    JXT.use(time_1.default);
    JXT.use(tune_1.default);
    JXT.use(upload_1.default);
    JXT.use(vcard_1.default);
    JXT.use(version_1.default);
    JXT.use(visibility_1.default);
    JXT.use(xrd_1.default);
}
exports.default = default_1;
